var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingCustomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.917,
    height: 18.75,
    viewBox: "0 0 27.917 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-426 -483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10445",
    "data-name": "Path 10445",
    d: "M31,8h4.633a1.166,1.166,0,0,1,.964.509l1.986,3.574h.583a1.144,1.144,0,0,1,1.167,1.289v3.96A1.168,1.168,0,0,1,39.167,18.5H38",
    transform: "translate(413.084 479.833)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10446",
    "data-name": "Path 10446",
    d: "M14,1h9.917V15.583h-8.75",
    transform: "translate(420.166 482.75)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    x1: 3,
    transform: "translate(428 498.5)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9222",
    "data-name": "Ellipse 9222",
    cx: 2.339,
    cy: 2.328,
    rx: 2.339,
    ry: 2.328,
    transform: "translate(446.406 496.594)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9223",
    "data-name": "Ellipse 9223",
    cx: 2.339,
    cy: 2.328,
    rx: 2.339,
    ry: 2.328,
    transform: "translate(430.666 496.594)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10447",
    "data-name": "Path 10447",
    d: "M33,14.333h4.083v-.585L35.917,12",
    transform: "translate(412.25 478.167)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    x2: 10,
    transform: "translate(426 490.5)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    "data-name": "Line 405",
    x2: 8,
    transform: "translate(431 487.5)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    x1: 2,
    transform: "translate(428 487.5)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    "data-name": "Line 407",
    x1: 1,
    transform: "translate(432 483.5)",
    fill: "none",
    stroke: "#6b727d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingCustomIcon);
export default __webpack_public_path__ + "static/media/shipping-custom-icon.e93a158e9fc24fd1a08c335022cf9ce8.svg";
export { ForwardRef as ReactComponent };